/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum FIELD_ATTRS_LIST {
  NAME = "name",
  DESCRIPTION = "description",
  ORIGIN = "origin",
  CLAUSE = "clause",
  TYPE = "type",
  AGGREGATION = "aggregation",
  ORDER = "order",
  SCALE = "scale",
  PRECISION = "precision",
  BITWIDTH = "bit-width",
  UNIT = "unit",
  TIMEZONE = "timezone",
  NULLABLE = "nullable",
}
